function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".star-1{fill:#fff;}.filled .star-1{fill:#faec21;}.star-2{fill:none;stroke:#fff9ca;stroke-miterlimit:10;stroke-width:3px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "star");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "star-1",
  d: "M25.1,2c-2.83,2.55-6,7-6,14.35A11.61,11.61,0,0,0,24.6,26a11.17,11.17,0,0,1,.49-1.27,11.27,11.27,0,0,1,6.54-6.71c-.23-7.49-4.16-14-6.53-16"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-2",
  d: "M25.1,2c-2.83,2.55-6,7-6,14.35A11.61,11.61,0,0,0,24.6,26a11.17,11.17,0,0,1,.49-1.27,11.27,11.27,0,0,1,6.54-6.71C31.4,10.56,27.47,4.08,25.1,2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-1",
  d: "M1.91,18.13c1.54,3.48,4.82,7.84,11.8,10.1A11.57,11.57,0,0,0,24.6,26a11.46,11.46,0,0,1-1.05-.86,11.27,11.27,0,0,1-4.36-8.29c-7.2-2.1-14.58-.37-17.28,1.25"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-2",
  d: "M1.91,18.13c1.54,3.48,4.82,7.84,11.8,10.1A11.57,11.57,0,0,0,24.6,26a11.46,11.46,0,0,1-1.05-.86,11.27,11.27,0,0,1-4.36-8.29C12,14.78,4.61,16.51,1.91,18.13Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-1",
  d: "M10.08,45.17c3.79-.39,8.94-2.17,13.25-8.1A11.57,11.57,0,0,0,24.6,26a11.43,11.43,0,0,1-1.14.73,11.24,11.24,0,0,1-9.23,1.59C10,34.54,9.38,42.1,10.08,45.17"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-2",
  d: "M10.08,45.17c3.79-.39,8.94-2.17,13.25-8.1A11.57,11.57,0,0,0,24.6,26a11.43,11.43,0,0,1-1.14.73,11.24,11.24,0,0,1-9.23,1.59C10,34.54,9.38,42.1,10.08,45.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-1",
  d: "M38.32,45.75c.8-3.72.7-9.17-3.61-15.11A11.55,11.55,0,0,0,24.6,26,9.77,9.77,0,0,1,25,27.34a11.26,11.26,0,0,1-1.35,9.27c4.59,5.92,11.58,8.86,14.72,9.14"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-2",
  d: "M38.32,45.75c.8-3.72.7-9.17-3.61-15.11A11.55,11.55,0,0,0,24.6,26,9.77,9.77,0,0,1,25,27.34a11.26,11.26,0,0,1-1.35,9.27C28.19,42.53,35.18,45.47,38.32,45.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-1",
  d: "M47.6,19.08c-3.29-1.91-8.51-3.51-15.48-1.25A11.59,11.59,0,0,0,24.6,26,9.6,9.6,0,0,1,26,26.1a11.3,11.3,0,0,1,8.4,4.15c7-2.54,12-8.28,13.24-11.17"
}), /*#__PURE__*/React.createElement("path", {
  className: "star-2",
  d: "M47.6,19.08c-3.29-1.91-8.51-3.51-15.48-1.25A11.59,11.59,0,0,0,24.6,26,9.6,9.6,0,0,1,26,26.1a11.3,11.3,0,0,1,8.4,4.15C41.41,27.71,46.36,22,47.6,19.08Z"
})));

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.5 47.37",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.067758f5.svg";
export { ForwardRef as ReactComponent };